<template>
    <div class="login-container">
        <el-form autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm" label-position="left"
                 label-width="0px"
                 class="card-box login-form">
            <div class="logo">
                <img :src="logo" alt="Viability Logo">
            </div>
            <div class="el-form-group">
                <el-form-item prop="username">
                <span class="svg-container svg-container_login">
                    <svgicon icon="users"/>
                </span>
                    <el-input name="username" type="text" v-model="loginForm.username" autoComplete="on"
                              placeholder="username"/>
                </el-form-item>
                <el-form-item prop="password">
                <span class="svg-container">
                  <svgicon name="key"></svgicon>
                </span>
                    <el-input
                            name="password"
                            :type="pwdType"
                            v-model="loginForm.password"
                            autoComplete="on"
                            placeholder="password"
                            ref="password-input"
                    />
                </el-form-item>
            </div>
            <el-button type="primary" style="width:100%;" :loading="loading" @click="handleLogin">
                Sign in
            </el-button>
        </el-form>
    </div>
</template>

<script>
    import {isvalidEmail} from '@/utils/validate'
    import background from '@/assets/background.jpg'
    import logo from '@/assets/logo.svg'
    import {setAuthHeaderToken} from 'Repositories/apiRepository';

    export default {
        name: 'login',
        data() {
            const validateUsername = (rule, value, callback) => {
                if (!isvalidEmail(value)) {
                    callback(new Error('Invalid Username'))
                } else {
                    callback()
                }
            };

            const validatePass = (rule, value, callback) => {
                if (value.length < 5) {
                    callback(new Error('Invalid Password'))
                } else {
                    callback()
                }
            };

            return {
                background,
                logo,
                loginForm: {
                    username: '',
                    password: ''
                },
                loginRules: {
                    username: [{required: true, trigger: 'blur', validator: validateUsername}],
                    password: [{required: true, trigger: 'blur', validator: validatePass}]
                },
                loading: false,
                pwdType: 'password'
            }
        },

        mounted() {
            this.$refs['password-input'].$el.querySelector('input').addEventListener('keydown', this.handlePasswordKeydown);
        },

        beforeDestroy() {
            this.$refs['password-input'].$el.querySelector('input').removeEventListener('keydown', this.handlePasswordKeydown);
        },

        methods: {
            handlePasswordKeydown(e) {
                if (e.code === 'Enter') {
                    this.handleLogin();
                }
            },

            handleLogin() {
                this._validateForm();
            },

            _validateForm() {
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.$store.dispatch('user/Login', this.loginForm).then(token => {
                            setAuthHeaderToken(token);
                            this.loading = false;
                            this.$router.push({path: '/'})
                        }).catch((err) => {
                            this.$message.error(err.message);
                            this.loading = false
                        })
                    } else {
                        return false
                    }
                })
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    @import '../styles/variables';

    .login-container {
        position        : fixed;
        width           : 100%;
        height          : 100%;
        display         : flex;
        justify-content : center;
        margin          : 0 auto;

        .background {
            position        : absolute;
            width           : 100%;
            height          : 100%;
            object-fit      : cover;
            object-position : left;
            opacity         : 0.5;
        }

        .tips {
            font-size     : 14px;
            color         : #FFFFFF;
            margin-bottom : 10px;
        }

        .svg-container {
            padding        : 6px 5px 6px 15px;
            vertical-align : middle;
            width          : 30px;
            display        : inline-block;

            &_login {
                font-size : 20px;
            }
        }

        .login-form {
            margin-top       : 200px;
            position         : relative;
            background-color : #FFFFFF;
            border-radius    : 12px;
            width            : 500px;
            height           : 415px;
            padding          : 105px 35px 15px 35px;
            overflow         : hidden;
            box-shadow       : $box-shadow;

            .logo {
                position         : absolute;
                top              : 0;
                left             : 0;
                width            : 100%;
                height           : 80px;
                background-color : $blue;
                display          : flex;
                justify-content  : center;
                align-items      : center;
            }

            .el-form-group {
                padding : 40px 0;

                .el-form-item {
                    border        : 1px solid rgba(255, 255, 255, 0.1);
                    background    : #E5E5E5;
                    border-radius : 5px;
                    color         : #000000;

                    .el-form-item__content {
                        display : flex;

                        .el-input {
                            height          : 52px;
                            width           : 85%;
                            display         : flex;
                            justify-content : center;
                            align-items     : center;

                            input:-webkit-autofill {
                                -webkit-box-shadow      : 0 0 0px 1000px #E5E5E5 inset !important;
                                -webkit-text-fill-color : #000000 !important;
                            }

                            input {
                                background         : transparent;
                                border             : 0px;
                                -webkit-appearance : none;
                                border-radius      : 0px;
                                color              : #000000;
                                height             : 47px;
                            }
                        }

                        .show-pwd {
                            position    : absolute;
                            right       : 10px;
                            top         : 7px;
                            font-size   : 16px;
                            color       : #000000;
                            cursor      : pointer;
                            user-select : none;
                        }
                    }
                }
            }
        }

        .thirdparty-button {
            position : absolute;
            right    : 35px;
            bottom   : 28px;
        }
    }
</style>
